/**
 * Expected input like `0` or `12`, etc.
 * @param hour
 */
const formatHour = (hour: string | number) => `${String(hour).padStart(2, '0')}:00`;

export default formatHour;
